module.exports = __webpack_public_path__ + "static/Derby2023-2-c429b789f7c889268734d917d80a9d06.png";